import React, { Suspense } from 'react';
import About from '../components/About';
import Contact from '../components/Contact';
import Hero from '../components/Hero';
import Project from '../components/Project';
import Skill from '../components/Skill';

const Home = () => {
    return (
        <Suspense
            fallback={
                <div className='sk-folding-cube'>
                    <div className='sk-cube1 sk-cube'></div>
                    <div className='sk-cube2 sk-cube'></div>
                    <div className='sk-cube4 sk-cube'></div>
                    <div className='sk-cube3 sk-cube'></div>
                </div>
            }
        >
            <div className='  mx-auto  '>


                <Hero />
                <Project />
                <Skill />
                <About></About>
                <Contact />

            </div>
        </Suspense>
    );
};

export default Home;